import { createSelector as createReselectSelector } from 'reselect';
import { createSelector } from 'redux-orm';
import { orm } from 'model';
import { convertToDays } from '../util';

export const selectorCount = createSelector(
  orm,
  (state, props) => props,
  ({ AutopayAudit }, { id }) =>
    AutopayAudit.filter(({ payeeId }) => payeeId === id).count()
);

const selectorId = createSelector(
  orm,
  (state, props) => props,
  ({ AutopayAudit }, { autopayId }) =>
    AutopayAudit.filter(
      ({ autopayId: auditAutopayId }) => auditAutopayId === autopayId
    ).toModelArray()
);

export const selectorGroupedByDays = createReselectSelector(
  selectorId,
  (items) => items.reduce(convertToDays, [])
);
